import React from "react";
import BaseInput from "../../../toolkit/baseInput";

export const PromocionBeneficioProductoSelector = ({
  value,
  disabled,
  onChange,
  size = "sm",
  beneficios
}) => (
  <BaseInput
    label="Beneficio Descuento"
    name="promocionBeneficioProductoSelector"
    type="select"
    id="promocionBeneficioProductoSelector"
    placeholder="Beneficio Descuento"
    value={value}
    size={size}
    disabled={disabled}
    onChange={e => {
      const value = e.target.value;
      return onChange(value);
    }}
    options={[{ label: "Sin beneficio", id: "" }].concat(
      beneficios.map(b => {
        return { label: b.productoNombre + " - " + b.descuento, value: b.id };
      })
    )}
  />
);
